import { FieldError } from "react-hook-form";
import ReactMarkdown from "react-markdown";

export function ErrorMessageComponent({
  fieldError,
  componentId,
  multiple = false
}: {
  fieldError: FieldError | undefined;
  componentId?: string;
  multiple?: boolean;
}) {
  if (!fieldError) return <></>;

  if (fieldError.types && Object.keys(fieldError.types).length > 0) {
    const errorMessages: string[] = [];
    
    Object.values(fieldError.types).forEach((errorArray) => {
      if (Array.isArray(errorArray)) {
        errorMessages.push(...errorArray);
      } else if (typeof errorArray === 'string') {
        errorMessages.push(errorArray);
      }
    });

    // If multiple is false, only show the first error
    const displayErrors = multiple ? errorMessages : errorMessages.slice(0, 1);

    return (
      <div id={componentId + "-error-message-text"}>
        {displayErrors.map((error, index) => (
          <div key={index} className="mb-1 error-message text-xs">
            <ReactMarkdown>{error}</ReactMarkdown>
          </div>
        ))}
      </div>
    );
  }

  // Handle single error (fallback)
  if (!fieldError.message) return <></>;

  return (
    <div id={componentId + "-error-message-text"} className="error-message text-xs">
      <ReactMarkdown>{fieldError.message}</ReactMarkdown>
    </div>
  );
}
